import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom"
import { toSlug } from "../../lib/helpers/main"
import Skeleton from "react-loading-skeleton"
import { useQuery } from "../../lib/helpers/router"
import { IoArrowBackSharp } from "react-icons/io5"

const { useEffect, useState } = require("react")
const { useSelector, useDispatch } = require("react-redux")
const { toast } = require("react-toastify")
const { cerrarSesion } = require("../../redux/actions/session")
const { Spinner, Badge, Row, Card, Col, Dropdown, Button } = require("react-bootstrap")
const { urlapi, url_images } = require("../../lib/backend/data")

const CategoriasSelector = (props) => {
    const {
        condicion,
        typeView,
        default_category
    } = props
    const cond = condicion ? condicion : {}
    const [ categorias, setCategorias ] = useState([])
    const [ loading, setLoading ] = useState(true)
    const [ catSeleccionada, setCatSeleccionada ] = useState(null)
    const sitio = useSelector(state => state.sitio)
    const [ seleccionado, setSeleccionado ] = useState("todos")
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const params = useQuery()
    const location = useLocation()
    let estilo_todos = { borderRadius: 14, padding: "4px 18px", fontSize: 12, textTransform: "uppercase" }
    let estilo_apagado = { backgroundColor: "#dedede", color: "black", ...estilo_todos }
    let estilo_encendido = { backgroundColor: "#007bff", color: "white", ...estilo_todos }
    const [searchParams, setSearchParams] = useSearchParams();
    const [ init, setInit ] = useState(0)

    const validateInit = (cats) => {
        const currentCategory = searchParams.get("category")
        if(currentCategory) modificar(currentCategory, cats)
    }
    useEffect(() => {
        if(!init){
            obtenerDatos(true)
        } else {
            if(default_category) modificar(default_category)
        }
        setInit(init + 1)
    }, [ default_category ])

    const obtenerDatos = async (select_)=>{
        setLoading(true)
        return fetch(`${urlapi}/categorias/list-full`,{
            method:'POST',
            body: JSON.stringify({
                condicion: cond
            }),
            headers: {
                'Content-Type':'application/json',
            }
        })
        .then(res => {
            if(res.status === 401) return dispatch(cerrarSesion())
            return res.json()
        })
        .then(res => {
            if(!res){
                toast.error('Sin datos')
            } else if(res.errorMessage){
                toast.error(res.errorMessage)
            } else if(Array.isArray(res)){
                setCategorias(res)
                setTimeout(() => select_ === true ? validateInit(res) : false, 200);
            }
            return setLoading(false)
        })
        .catch(error => {
            toast.error("Error al consultar la información, intente nuevamente")
            return setLoading(false)
        })
    }

    const resetParam = (slug) => {
        const nuevos = new URLSearchParams(searchParams);
        nuevos.delete(slug);
        setSearchParams(nuevos, { replace: true });
    }

    const modificar = (key, cats) => {
        
        const categories = categorias.length > 0 ? categorias : cats
        console.log("modificar", categories)
        let llave = key?._id || key
        if(typeof key === "object"){

            if(seleccionado === key?._id){
                if(props.onSelect) props.onSelect("todos")
                setCatSeleccionada(null)
                setSeleccionado("todos")
                resetParam("category")

            } else {
                const slug = toSlug(key?.titulo ? key?.titulo : "")
                searchParams.category = slug
                setSearchParams({ category: slug });
                setSeleccionado(llave)
                if(props.onSelect) props.onSelect(key)
            }

        } else {
            if(key === "todos"){   
                setSeleccionado(llave)
                resetParam("category")
            } else {
                console.log(categories)
                const i = categories.findIndex(cat => cat.slug === llave)
                if(i > -1 ) {
                    console.log(categories[i])
                    setSeleccionado(categories[i]._id)
                    searchParams.category = toSlug(categories[i].titulo)
                    setSearchParams({ category: searchParams.category });
                    setCatSeleccionada(categories[i])
                    if(props.onSelect) props.onSelect(categories[i]._id)
                }
            }
        }
        

    }

    const select = (categoria) => {
        setCatSeleccionada(categoria)
        if(location.pathname !== "/"){
            return navigate(`/?category=${categoria._id}`)
        } else {
            modificar(categoria)
        }
    }

    const viewMenu = () => {
        return <div className="bg-white mr-5">
            <Dropdown>
            <Dropdown.Toggle variant="white" className="py-0" style={{ color: "#7f7f7f" }}>Productos</Dropdown.Toggle>
            <Dropdown.Menu>
                {
                    loading ? <div className="p-3"><Skeleton height={30} count={4} className="mb-1" /></div> : categorias.map((categoria, key) => {
                        return <Dropdown.Item key={`cat-${categoria._id}`} className="mb-0 p-3 hover" onClick={() => select(categoria)}>
                            {categoria.img ? <img src={categoria.img} className="mr-2" alt={categoria.titulo} style={{ width: 30, height: 30, borderRadius: 5 }} /> : false}
                            {categoria.titulo}
                        </Dropdown.Item>
                    })
                }
            </Dropdown.Menu>
          </Dropdown>
            
        </div>
    }

    const viewTopBar = () => {
        const sizeItems = "100%"
        if(loading) return <Spinner animation="border" />
        return <div className="bg-white py-3 px-3 sticky-top" style={{ overflowY: "scroll" }}>
            {
                categorias.map((categoria, key) => {
                    return <h6 key={`cat-${categoria._id}`} className="mb-0 mr-4 d-inline hover" >{categoria.titulo}</h6>
                })
            }
        </div>
    }

    const view2 = () => {
        const sizeItems = "100%"
        if(loading) return <Spinner animation="border" />
        return <div>
            {/* <div className="text-center d-inline-block mr-4 hover mb-3" onClick={() => modificar("todos")}>
                        <div className="mb-2" style={{ margin: "0 auto", border: seleccionado === "todos" ? "3px solid black" : "none", height: sizeItems, width: sizeItems, borderRadius: "50%", backgroundImage: `url('${`${url_images}/product.png`}' )`, backgroundPosition: "center center" }} />
            <h6  className=" d-inline-block hover" >Todos</h6>
            </div> */}
            
            <Row>
            {
                categorias.map((categoria, key) => {
                    return <Col md={2} xs={4} className="text-center d-inline-block mb-2" style={{ opacity: seleccionado !== "todos" && seleccionado !== categoria._id ? 0.4 : 1 }} key={categoria._id} onClick={() => modificar(categoria)}>
                        <div className="mb-2 hover" style={{ margin: "0 auto", aspectRatio: "1/1", width: sizeItems, border: seleccionado === categoria._id ? "3px solid black" : "none", borderRadius: 20, backgroundImage: `url('${categoria.img ? categoria.img : `${url_images}/product.png`}' )`, backgroundSize: "contain", backgroundPosition: "center center", backgroundRepeat: "no-repeat",  }} />
                        <h6 className="mb-0" >{categoria.titulo}</h6>
                    </Col>
                })
            }
            </Row>
            {catSeleccionada?.titulo ? <h2>{catSeleccionada?.titulo} <Button size="sm" onClick={() => modificar("todos")}><IoArrowBackSharp /> VOLVER A VER TODOS</Button></h2> : false }
        </div>
    }

    const view1 = () => {
        const isMobile = window.innerWidth < 768
        const sizeItems = isMobile ? 70 : 100
        if(loading) return <Spinner animation="border" />
        return <div>
            <div className="text-center d-inline-block mr-4 hover mb-3" onClick={() => modificar("todos")}>
                        <div className="mb-2" style={{ margin: "0 auto", border: seleccionado === "todos" ? "3px solid black" : "none", height: sizeItems, width: sizeItems, borderRadius: "50%", backgroundImage: `url('${`${url_images}/product.png`}' )`, backgroundPosition: "center center" }} />
            <h6  className=" d-inline-block hover" >Todos</h6>
            </div>
            {
                categorias.map((categoria, key) => {
                    return <div className="text-center d-inline-block mr-4 mb-3" key={categoria._id} onClick={() => modificar(categoria)}>
                        <div className="mb-2 hover" style={{ margin: "0 auto", height: sizeItems, width: sizeItems, border: seleccionado === categoria._id ? "3px solid black" : "none", borderRadius: "50%", backgroundImage: `url('${categoria.img ? categoria.img : `${url_images}/product.png`}' )`, backgroundSize: "cover", backgroundPosition: "center center" }} />
                        <h6 className="mb-0" >{categoria.titulo}</h6>
                    </div>
                })
            }
        </div>
    }

    const mostrarDatos = () => {
        if(typeView === "topbar") return viewTopBar()
        if(typeView === "menu") return viewMenu()
        if(sitio.type_view_categories === "2"){
        return view2()
        }
        return view1()
    }

    return <div>
        {mostrarDatos()}
    </div>
}

export default CategoriasSelector